/** Enable only in a release carrying a complete, reviewed property package. */
export const preparedTerrainEnabled=import.meta.env.VITE_PREPARED_TERRAIN_ENABLED==='true';
